import React from 'react';

export function EmojiIcon({backgroundColor, emoji}) {
    return <div style={{
        width: '44px',
        height: '44px',
        backgroundColor: backgroundColor,
        borderRadius: '13px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '18px'
    }}>{emoji}</div>
}
